import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import DatePicker from 'vue2-datepicker'
import PageTracker from '../../../common/PageTrackerHelper';
import moment from 'moment'

export default {
  name: 'DeliverySummery',
  components: {VueElementLoading,Paginate,DatePicker},
  props: [],
  mixins:[PageTracker],
  data() {
    return {
      ListLoading:false,
      searchData:'',
      pageno:null,
      shipmentTypeData:[],
      total:{},
      pagecount:1,
      showList:false,
      date:'',
      userDataKey : '',
    }
  },
  created: function(){

  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userrole = userdetail.userrole;
    this.userid = userdetail.userid
    this.localusermailid = userdetail.username;

    // let TrackerInfo = {
    //   projectname:"Lastmile-web",
    //   type:"Web",
    //   userid:this.userid,
    //   username:this.localusermailid,
    //   meta: {
    //     "event":""
    //   }
    // }
    // let result  = this.PageTracker(TrackerInfo);
    //console.log('Mixin is working for :',result);
  },
  methods: {

    getShipmentList(){
      if (this.date === '') {
        this.$alertify.error("Please Select Date")
        return false
      }
      this.ListLoading = true
      this.shipmentTypeData = []
      let todayDate =  moment(this.date).format('YYYY-MM-DD')
      let input = {
        page:this.pageno!==null?this.pageno:0,
        perPage:10,
        TodayDate: todayDate
      }
      this.showList = true
      axios.post(apiUrl.api_url + "getShipmentType/get",input)
      .then(async result =>{

        this.total =
        {
          AllocatedToSR:0,
          OutForDelivery:0,
          Delivered_PickDone_WHHandover:0,
          NDR_NPR:0,
          Total:0
        }
        this.ListLoading=false

        if (result.data.code === 200){

          var totalCount = result.data.data.count.length;

          result.data.data.rows.map(row =>{
            this.shipmentTypeData.push({
              shipmenttype:row.shipmenttype,
              AllocatedToSR:row.AllocatedToSR,
              OutForDelivery:row.OutForDelivery,
              Delivered_PickDone_WHHandover:row.Delivered_PickDone_WHHandover,
              NDR_NPR:row.NDR_NPR,
              Total:parseInt(row.OutForDelivery) + parseInt(row.Delivered_PickDone_WHHandover) + parseInt(row.NDR_NPR)
            })
          })

          await this.shipmentTypeData.forEach(async item => {
            this.total = {
              shipmenttype:'Total',
              AllocatedToSR : this.total.AllocatedToSR + parseInt(item.AllocatedToSR),
              OutForDelivery : this.total.OutForDelivery + parseInt(item.OutForDelivery),
              Delivered_PickDone_WHHandover : this.total.Delivered_PickDone_WHHandover + parseInt(item.Delivered_PickDone_WHHandover),
              NDR_NPR : this.total.NDR_NPR + parseInt(item.NDR_NPR),
              Total : this.total.Total + parseInt(item.Total)
            }
          });

          this.shipmentTypeData.push(this.total)

          if (totalCount < 10) {
            this.pagecount = 1;
          } else {
            this.pagecount = Math.ceil(totalCount / 10)
          }
        }else {
          this.shipmentTypeData =[];
          this.ListLoading=false;
        }
      }).catch(err => {
        this.ListLoading=false
        console.log("Error Details", err);
      });
    },
    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * 10;
      this.getShipmentList();
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/DeliverySummery/DeliverySummery.component.js